// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ROOT_URL: process.env.REACT_APP_API_URL,
 // ROOT_URL: 'http://192.168.1.243:3000/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  TOKEN_VALIDITY: process.env.REACT_APP_API_TOKEN_VALIDITY,
  DEFAULT_TOKEN_VALIDITY: process.env.REACT_APP_DEFAULT_API_TOKEN_VALIDITY,
  defaultLanguage: process.env.REACT_APP_LANGUAGE,
};
